export function showNotification(title, message, type = 'info') {
    // Remover notificaciones existentes del mismo tipo
    const existingNotifications = document.querySelectorAll('.toast-notification');
    existingNotifications.forEach(notification => notification.remove());
    // Determinar la clase de color de fondo según el tipo
    let bgClass = 'text-bg-primary';
    if (type === 'success')
        bgClass = 'text-bg-success';
    if (type === 'warning')
        bgClass = 'text-bg-warning';
    if (type === 'info')
        bgClass = 'text-bg-info';
    // Crear notificación flotante
    const notificationHtml = `
            <div class="toast-notification toast align-items-center ${bgClass} border-0 show position-fixed top-0 end-0 m-3 toast-high-z-index toast-min-width" role="alert" aria-live="assertive" aria-atomic="true">
                <div class="d-flex">
                    <div class="toast-body">
                        <div class="d-flex align-items-center mb-1">
                            <i class="bi bi-${getNotificationIcon(type)} me-2 fs-5"></i>
                            <strong class="me-auto">${title}</strong>
                        </div>
                        <div class="ms-5">${message}</div>
                    </div>
                    <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close" onclick="this.closest('.toast-notification').remove()"></button>
                </div>
            </div>
        `;
    // Agregar al DOM
    document.body.insertAdjacentHTML('beforeend', notificationHtml);
    // La notificación permanecerá hasta que el usuario la cierre
}
export function getNotificationIcon(type) {
    switch (type) {
        case 'success':
            return 'check-circle-fill';
        case 'warning':
            return 'exclamation-triangle-fill';
        case 'info':
            return 'info-circle-fill';
        default:
            return 'info-circle-fill';
    }
}
